import { TicketCancelReasonFormType } from 'components/ticket-cancel-reasons/TicketCancelReasonForm';

export const updateTicketCancelReasonInitialValues: Partial<TicketCancelReasonFormType> = {};
